<template>
  <span>
    <v-btn @click.stop="setDialog(true)" class="ma-1" color="red" small text>Delete</v-btn>
    <v-dialog v-model="dialog" max-width="600" persistent>
      <delete-confirmation :record="record" @setDialog="setDialog"></delete-confirmation>
    </v-dialog>
  </span>
</template>

<script>
import DeleteConfirmation from "./AttachmentDeleteConfirmation";

export default {
  components: { DeleteConfirmation },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    async setDialog(val) {
      this.dialog = val;
    },
  },
  props: {
    record: { required: true, type: Object },
  },
};
</script>
